import Paper from '@material-ui/core/Paper';
import React, { Component } from 'react';

import { currencyFormatter } from '../../../utilities/currencyFormatter';
import { dateFormatter } from '../../../utilities/dateFormatter';

import {
  DataTypeProvider,
  FilteringState,
  IntegratedFiltering,
  IntegratedPaging,
  IntegratedSorting,
  PagingState,
  SortingState,
} from '@devexpress/dx-react-grid';

import {
  Grid,
  PagingPanel,
  Table,
  TableFilterRow,
  TableHeaderRow,
} from '@devexpress/dx-react-grid-material-ui';

const DateTypeProvider = (props) => (
  <DataTypeProvider formatterComponent={dateFormatter} {...props} />
);

const CurrencyTypeProvider = (props) => (
  <DataTypeProvider
    formatterComponent={currencyFormatter}
    {...props}
  />
);

const getRowId = (row) => row.id;

class OtherExceptions extends Component {
  constructor(props) {
    super(props);

    this.state = {
      columns: [
        { name: 'exceptDate', title: 'Date' },
        { name: 'exceptAmount', title: 'Requested Amt' },
        { name: 'program', title: 'Program Name' },
        { name: 'exceptDesc', title: 'Description' },
        { name: 'exceptReason', title: 'Reason' },
        { name: 'requestType', title: 'Request Type' },
        { name: 'status', title: 'Status' },
        { name: 'exceptApprovedBy', title: 'Approved By' },
        { name: 'approvedAmount', title: 'Approved Amount' },
        { name: 'approvedDate', title: 'Approved Date' },
      ],
      rows: this.props.rows,
      currentPage: 0,
      pageSize: 5,
      pageSizes: [5, 10, 15],
      dateColumns: ['exceptDate', 'approvedDate'],
      currencyColumns: ['approvedAmount', 'exceptAmount'],
      sorting: [{ columnName: 'exceptDate', direction: 'desc' }],
      filters: [],
    };

    this.changeSorting = (sorting) => this.setState({ sorting });
    this.changeFilters = (filters) => this.setState({ filters });
    this.changeCurrentPage = (currentPage) => this.setState({ currentPage });
    this.changePageSize = (pageSize) => this.setState({ pageSize });

    this.TableRow = ({ row, ...restProps }) => {
      return (
        <Table.Row
          {...restProps}
        />
      );
    };
  }

  render() {
    const { rows, columns, pageSize, pageSizes, currentPage, dateColumns, sorting, filters, currencyColumns } = this.state;

    return (
      <Paper style={{ padding: '1rem' }}>
        <div style={{ padding: '1rem', fontSize: '1.25rem' }}>Other Exceptions</div>
        <Grid rows={rows} columns={columns} getRowId={getRowId}>
          <DateTypeProvider for={dateColumns} />
          <CurrencyTypeProvider
            for={currencyColumns}
          />
          <SortingState
            sorting={sorting}
            onSortingChange={this.changeSorting}
          />
          <PagingState
            currentPage={currentPage}
            onCurrentPageChange={this.changeCurrentPage}
            pageSize={pageSize}
            onPageSizeChange={this.changePageSize}
          />
          <IntegratedSorting />
          <FilteringState
            filters={filters}
            onFiltersChange={this.changeFilters}
          />
          <IntegratedFiltering />
          <IntegratedPaging />
          <Table rowComponent={this.TableRow} />
          <TableHeaderRow showSortingControls />
          <TableFilterRow />
          <PagingPanel pageSizes={pageSizes} />
        </Grid>
      </Paper>
    );
  }
}

export default OtherExceptions;
